import { NodeProps } from 'reactflow';
import styled from 'styled-components/macro';
import { ReactComponent as CircleArrowRight } from '../../../images/icons/circle-arrow-right-solid.svg';
import { colourGreen09, colourGreen10 } from '../../../styling/colours';
import { PumpMapNodeData } from '../../shared/quote-or-design-form/map/mapNode';
import { MapFlowNodeReadOnly } from './MapFlowNodeReadOnly';

export const ReadOnlyPump = ({ data: { pump } }: NodeProps<PumpMapNodeData>) => {
  return <PumpFlowNode icon={<PumpIcon />} stats={[pump ?? '']} hasSource={true} hasTarget={true} title="Pump" />;
};

const PumpIcon = styled(CircleArrowRight)`
  height: 1em;
  width: 1em;
`;

const PumpFlowNode = styled(MapFlowNodeReadOnly)`
  border-color: ${colourGreen09};
  background: ${colourGreen10};
`;
